import { useState } from "react";

const navLinks = [
  { label: "首页", href: "#top" },
  { label: "每日热榜", href: "#hot-rank" },
  { label: "最新爆料", href: "#latest" },
  { label: "瓜田话题", href: "#category" },
  { label: "讨论圈", href: "#community" },
];

const tickerItems = [
  "今日热榜已刷新 26 条话题",
  "独家线索新增 18 条，值班编辑已完成核对",
  "黑料51瓜友热议：片场换角风波时间线已更新",
  "讨论圈今日新增 2,140 条回复",
];

export default function TopNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full" id="top">
      <div className="w-full bg-primary-600 text-background-50">
        <div className="flex h-9 items-center gap-3 overflow-hidden px-4 md:px-6 lg:px-8">
          <span className="flex shrink-0 items-center gap-1.5 text-xs font-medium">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-notification-3-line text-sm" />
            </span>
            今日快报
          </span>
          <span className="hidden h-3 w-px shrink-0 bg-background-50/30 sm:block" />
          <div className="relative flex-1 overflow-hidden">
            <div className="hl-marquee text-xs">
              {tickerItems.map((item) => (
                <span key={`a-${item}`} className="mr-10 whitespace-nowrap">
                  {item}
                </span>
              ))}
              {tickerItems.map((item) => (
                <span key={`b-${item}`} className="mr-10 whitespace-nowrap">
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="flex items-center justify-between gap-4 px-4 py-3 md:px-6 lg:px-8">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-alarm-warning-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
                黑料51
              </span>
              <span className="mt-0.5 text-[10px] font-medium uppercase tracking-[0.2em] text-foreground-500">
                吃瓜群众聚集地
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <label className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-2 xl:flex">
              <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
                <i className="ri-search-line text-base" />
              </span>
              <input
                type="text"
                placeholder="搜索话题 / 瓜友"
                className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </label>
            <a
              href="#join"
              className="hidden whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700 md:block"
            >
              投稿线索
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:px-6 lg:hidden">
            <nav className="flex flex-col">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="whitespace-nowrap rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#join"
                onClick={() => setOpen(false)}
                className="mt-2 whitespace-nowrap rounded-md bg-primary-600 px-3 py-2.5 text-center text-sm font-semibold text-background-50"
              >
                投稿线索
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}